export enum PaymentFrequency {
  Monthly = 0,
  FourWeekly = 1,
  Weekly = 2,
  QuarterYearly = 3,
  HalfYearly = 4,
  Yearly = 5,
  BiMonthly = 6,
  Fortnightly = 7,
  TriAnnually = 8,
}
